/* Compact size-filter selection for collection and search pages.
 * Moved out of snippets/active-facets.liquid (was ~24 KB inline on every
 * collection page). Guarded, so a re-rendered snippet never runs it twice.
 */
if (!window.fendoCompactSelectionReady) {
  window.fendoCompactSelectionReady = true;
  let panel;
  let trigger;
  let source;
  let pending = false;
  let initialVisitHandled = false;
  let autoPromptPending = false;
  function readPreference() {
    const read = value => {
      try {
        const state = JSON.parse(value || '{}');
        return state && typeof state === 'object' && Number(state.expires) > Date.now() ? state : null;
      } catch (_) { return null; }
    };
    let state;
    try { state = read(localStorage.getItem('fendo_size')); } catch (_) {}
    if (!state) {
      const cookie = document.cookie.split('; ').find(item => item.startsWith('fendo_size='));
      try { state = read(cookie && decodeURIComponent(cookie.slice(11))); } catch (_) {}
    }
    return state || {};
  }
  function promptSeen() {
    try { if (Number(localStorage.getItem('fendo_size_prompt_seen')) > Date.now()) return true; } catch (_) {}
    return document.cookie.split('; ').some(item => item.startsWith('fendo_size_prompt_seen='));
  }
  function markPromptSeen() {
    try { localStorage.setItem('fendo_size_prompt_seen', String(Date.now() + 30 * 86400000)); } catch (_) {}
    document.cookie = 'fendo_size_prompt_seen=1;path=/;max-age=2592000;SameSite=Lax;Secure';
  }
  function initialAction(url, saved, seen) {
    if (url.searchParams.get('size') === '1') return 'prompt';
    const explicit = url.searchParams.has('page') || Array.from(url.searchParams.keys()).some(key => key.startsWith('filter.') || key.startsWith('fendo_size_'));
    if (explicit) return 'none';
    if (saved.mode === 'filtered') return 'restore';
    return !saved.mode && !seen ? 'prompt' : 'none';
  }
  function selectionURL() {
    const url = new URL(location.href);
    const ownsStock = url.searchParams.get('fendo_size_stock') === '1';
    panel.querySelectorAll('[data-size-parameter]').forEach(group => url.searchParams.delete(group.dataset.sizeParameter));
    for (const name of ['suit', 'top', 'trouser', 'shoe', 'other']) url.searchParams.delete('fendo_size_' + name);
    const pairs = new Set();
    const values = [];
    const groups = {};
    panel.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
      const pair = input.name + ':' + input.value;
      if (!pairs.has(pair)) url.searchParams.append(input.name, input.value);
      pairs.add(pair);
      const group = input.closest('[data-size-group]').dataset.sizeGroup;
      url.searchParams.append('fendo_size_' + group, input.value);
      (groups[group] ||= []).push(input.value);
      values.push(input.value);
    });
    url.searchParams.delete('page');
    url.searchParams.delete('size');
    if (values.length) {
      if (ownsStock || url.searchParams.get('filter.v.availability') !== '1') url.searchParams.set('fendo_size_stock', '1');
      url.searchParams.set('filter.v.availability', '1');
    } else if (ownsStock) {
      url.searchParams.delete('filter.v.availability');
      url.searchParams.delete('fendo_size_stock');
    }
    return { url, values: [...new Set(values)], groups };
  }
  const copy = {
    de: { sizes: 'Grössen', title: 'Grössen auswählen', description: 'Wählen Sie eine oder mehrere Grössen. Es werden Modelle in mindestens einer Ihrer ausgewählten Grössen angezeigt.', apply: 'Produkte anzeigen', reset: 'Alle Grössen anzeigen', close: 'Auswahl schliessen' },
    en: { sizes: 'Sizes', title: 'Select sizes', description: 'Choose one or more sizes. Styles available in at least one of your selected sizes will be shown.', apply: 'Show products', reset: 'Show all sizes', close: 'Close selection' }
  };
  const groupNames = {
    de: { suit: 'Anzüge & Bekleidung · EU', top: 'Hemden, Polos & Strick', trouser: 'Hosen · Bundweite', shoe: 'Schuhe · EU', other: 'Weitere Grössen', none: 'Keine ausgewählt' },
    en: { suit: 'Suits & clothing · EU', top: 'Shirts, polos & knitwear', trouser: 'Trousers · waist size', shoe: 'Shoes · EU', other: 'Other sizes', none: 'None selected' }
  };
  function readGroups(url) {
    const groups = {};
    for (const name of ['suit', 'top', 'trouser', 'shoe', 'other']) {
      const values = url.searchParams.getAll('fendo_size_' + name);
      if (values.length) groups[name] = [...new Set(values)];
    }
    return groups;
  }
  function carrySizeGroups(target, current, parameters) {
    // Shopify's native pagination does not retain custom query parameters.
    // Keep group identity only while its native size value is still selected.
    if (target.origin !== current.origin || target.pathname !== current.pathname) return target;
    const selected = new Set(parameters.flatMap(parameter => target.searchParams.getAll(parameter)));
    const groups = readGroups(current);
    for (const name of ['suit', 'top', 'trouser', 'shoe', 'other']) {
      const key = 'fendo_size_' + name;
      target.searchParams.delete(key);
      for (const value of groups[name] || []) {
        if (selected.has(value)) target.searchParams.append(key, value);
      }
    }
    if (selected.size && current.searchParams.get('fendo_size_stock') === '1' && target.searchParams.get('filter.v.availability') === '1') {
      target.searchParams.set('fendo_size_stock', '1');
    } else target.searchParams.delete('fendo_size_stock');
    return target;
  }
  function updatePaginationLinks(section, template) {
    const parameters = [...new Set(Array.from(template.content.querySelectorAll('[data-size-parameter]')).map(group => group.dataset.sizeParameter))];
    const current = new URL(location.href);
    section.querySelectorAll('nav.pagination a[href]').forEach(link => {
      const target = carrySizeGroups(new URL(link.href, location.href), current, parameters);
      if (target.href !== link.href) link.href = target.href;
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('nav.pagination a[href]');
    const section = link?.closest('.shopify-section--main-collection');
    const template = section?.querySelector('template[data-fendo-size-options]');
    if (!template) return;
    const parameters = [...new Set(Array.from(template.content.querySelectorAll('[data-size-parameter]')).map(group => group.dataset.sizeParameter))];
    const target = carrySizeGroups(new URL(link.href, location.href), new URL(location.href), parameters);
    if (target.href !== link.href) link.href = target.href;
  }, true);
  // Prestige builds filter and sorting URLs from FormData, not the current URL.
  // Carry only group selections that still exist in the submitted size filter.
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('facets-form')) return;
    const template = document.querySelector('[data-fendo-facet-source] template[data-fendo-size-options]');
    if (!template) return;
    const parameters = Array.from(template.content.querySelectorAll('[data-size-parameter]')).map(group => group.dataset.sizeParameter);
    const submittedSizes = new Set(parameters.flatMap(parameter => event.formData.getAll(parameter).map(String)));
    const groups = readGroups(new URL(location.href));
    for (const name of ['suit', 'top', 'trouser', 'shoe', 'other']) {
      const parameter = 'fendo_size_' + name;
      event.formData.delete(parameter);
      for (const value of groups[name] || []) {
        if (submittedSizes.has(value)) event.formData.append(parameter, value);
      }
    }
    if (submittedSizes.size && new URL(location.href).searchParams.get('fendo_size_stock') === '1' && String(event.formData.get('filter.v.availability')) === '1') {
      event.formData.set('fendo_size_stock', '1');
    } else event.formData.delete('fendo_size_stock');
  }, true);
  function updateGroupSummaries() {
    const text = groupNames[source.dataset.language] || groupNames.de;
    panel.querySelectorAll('[data-size-group]').forEach(group => {
      const values = Array.from(group.querySelectorAll('input:checked')).map(input => input.value);
      group.querySelector('.fendo-selection-group-summary').textContent = values.length ? values.join(' · ') : text.none;
    });
  }
  function persist(values, selectedGroups) {
    const state = { sizes: values, mode: values.length ? 'filtered' : 'all', expires: Date.now() + 30 * 86400000 };
    state.groups = selectedGroups;
    // Preserve product preselection only when a group has one unambiguous size.
    const groups = { suit: ['44','46','48','50','52','54','56','58','60','62'], top: ['S','M','L','XL','2XL','3XL'], shoe: ['39','40','40.5','41','42','42.5','43','43.5','44','45','46'] };
    for (const [name, sizes] of Object.entries(groups)) {
      const matches = (selectedGroups[name] || []).filter(value => sizes.includes(value));
      if (matches.length === 1) state[name] = matches[0];
    }
    const value = JSON.stringify(state);
    try { localStorage.setItem('fendo_size', value); } catch (_) {}
    document.cookie = 'fendo_size=' + encodeURIComponent(value) + ';path=/;max-age=2592000;SameSite=Lax;Secure';
  }
  function publishSizeSelection(values, groups) {
    // Emit only a customer's explicit selection, not restores or pagination.
    // Existing Shopify pixels decide how to consume the consent-managed event.
    if (!values.length || typeof window.Shopify?.analytics?.publish !== 'function') return null;
    try {
      return window.Shopify.analytics.publish('fendo:SizeSelected', {
        sizes: [...values],
        groups,
        collection: source.dataset.collectionHandle || '',
        source: 'size_selector'
      });
    } catch (_) { return null; }
  }
  function ensurePanel() {
    if (panel) return;
    panel = document.createElement('dialog');
    panel.id = 'fendo-selection-panel';
    panel.setAttribute('aria-labelledby', 'fendo-selection-panel-title');
    panel.setAttribute('aria-describedby', 'fendo-selection-panel-description');
    panel.innerHTML = '<header class="fendo-selection-panel__header"><h2 class="fendo-selection-panel__title" id="fendo-selection-panel-title"></h2><button type="button" class="fendo-selection-panel__close" data-selection-close autofocus>×</button></header><div class="fendo-selection-panel__body"><p class="fendo-selection-panel__description" id="fendo-selection-panel-description"></p><div data-selection-content></div></div><footer class="fendo-selection-panel__footer"><button type="button" class="fendo-selection-panel__primary" data-selection-apply></button><button type="button" class="fendo-selection-panel__secondary" data-selection-reset></button></footer>';
    document.body.append(panel);
    panel.addEventListener('change', updateGroupSummaries);
    panel.addEventListener('click', event => {
      if (event.target === panel) {
        const bounds = panel.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) panel.close();
      }
      if (event.target.closest('[data-selection-close]')) panel.close();
      if (event.target.closest('[data-selection-reset]')) {
        panel.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        const { url } = selectionURL();
        persist([], {});
        panel.close();
        location.assign(url.href);
        return;
      }
      if (event.target.closest('[data-selection-apply]')) {
        const { url, values, groups } = selectionURL();
        persist(values, groups);
        panel.close();
        const published = publishSizeSelection(values, groups);
        const navigate = () => location.assign(url.href);
        if (published && typeof published.then === 'function') {
          // Analytics must never block the shopping journey.
          Promise.race([published, new Promise(resolve => setTimeout(resolve, 250))]).then(navigate, navigate);
        } else navigate();
      }
      if (event.target.closest('a')) panel.close();
    });
    panel.addEventListener('close', () => {
      document.querySelectorAll('.fendo-size-summary-button').forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (trigger?.isConnected) trigger.focus();
    });
  }
  function openPanel(nextSource, nextTrigger, show = true) {
    ensurePanel();
    source = nextSource;
    trigger = nextTrigger;
    const text = copy[source.dataset.language] || copy.de;
    panel.querySelector('h2').textContent = text.title;
    panel.querySelector('.fendo-selection-panel__description').textContent = text.description;
    const content = panel.querySelector('[data-selection-content]');
    content.replaceChildren(source.querySelector('template[data-fendo-size-options]').content.cloneNode(true));
    const letterOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL'];
    content.querySelectorAll('.fendo-selection-sizes__grid').forEach(grid => {
      const options = Array.from(grid.children);
      options.sort((a, b) => {
        const left = a.querySelector('input').value;
        const right = b.querySelector('input').value;
        const leftNumber = /^\d+(\.\d+)?$/.test(left);
        const rightNumber = /^\d+(\.\d+)?$/.test(right);
        if (leftNumber && rightNumber) return Number(left) - Number(right);
        if (leftNumber !== rightNumber) return leftNumber ? -1 : 1;
        const leftIndex = letterOrder.indexOf(left.toUpperCase());
        const rightIndex = letterOrder.indexOf(right.toUpperCase());
        if (leftIndex >= 0 && rightIndex >= 0) return leftIndex - rightIndex;
        return left.localeCompare(right, undefined, { numeric: true });
      });
      grid.replaceChildren(...options);
    });
    const url = new URL(location.href);
    let selectedGroups = readGroups(url);
    const parameters = Array.from(content.querySelectorAll('[data-size-parameter]')).map(group => group.dataset.sizeParameter);
    if (!Object.keys(selectedGroups).length && !parameters.some(parameter => url.searchParams.has(parameter))) {
      const saved = readPreference();
      if (saved.mode === 'filtered') selectedGroups = saved.groups || {};
    }
    const hasGroups = Object.keys(selectedGroups).length > 0;
    const names = groupNames[source.dataset.language] || groupNames.de;
    const originalGroups = Array.from(content.querySelectorAll('fieldset'));
    for (const original of originalGroups) {
      const options = Array.from(original.querySelectorAll('label'));
      const buckets = { suit: [], top: [], trouser: [], shoe: [], other: [] };
      for (const option of options) {
        const value = option.querySelector('input').value;
        const numeric = /^\d+(\.\d+)?$/.test(value);
        if (source.dataset.shoeCollection === 'true') buckets.shoe.push(option);
        else if (!numeric) buckets.top.push(option);
        else {
          const size = Number(value);
          if (size >= 44 && size % 2 === 0) buckets.suit.push(option.cloneNode(true));
          else if (size <= 40 && size !== 39 && Number.isInteger(size)) buckets.trouser.push(option.cloneNode(true));
          else if (source.dataset.mixedCollection !== 'true') buckets.other.push(option.cloneNode(true));
          if (source.dataset.mixedCollection === 'true' && size >= 39 && size <= 46) buckets.shoe.push(option.cloneNode(true));
        }
      }
      for (const [name, labels] of Object.entries(buckets)) {
        if (!labels.length) continue;
        const group = document.createElement('fieldset');
        group.className = 'fendo-selection-sizes';
        group.dataset.sizeGroup = name;
        group.dataset.sizeParameter = original.dataset.sizeParameter;
        const legend = document.createElement('legend');
        legend.textContent = names[name];
        const summary = document.createElement('span');
        summary.className = 'fendo-selection-group-summary';
        legend.append(summary);
        const grid = document.createElement('div');
        grid.className = 'fendo-selection-sizes__grid';
        for (const label of labels) {
          const input = label.querySelector('input');
          input.checked = hasGroups ? (selectedGroups[name] || []).includes(input.value) : url.searchParams.getAll(input.name).includes(input.value);
          grid.append(label);
        }
        group.append(legend, grid);
        content.append(group);
      }
      original.remove();
    }
    updateGroupSummaries();
    panel.querySelector('[data-selection-apply]').textContent = text.apply;
    panel.querySelector('[data-selection-reset]').textContent = text.reset;
    panel.querySelector('[data-selection-close]').setAttribute('aria-label', text.close);
    if (show && !panel.open) {
      autoPromptPending = false;
      markPromptSeen();
      if (url.searchParams.get('size') === '1') {
        url.searchParams.delete('size');
        history.replaceState(history.state, '', url.href);
      }
      trigger.setAttribute('aria-expanded', 'true');
      panel.showModal();
    }
  }
  function sync() {
    document.querySelectorAll('[data-fendo-facet-source]').forEach(nextSource => {
      enhanceEmptyState(nextSource);
      const toolbar = nextSource.closest('.shopify-section')?.querySelector('.collection-toolbar');
      const template = nextSource.querySelector('template[data-fendo-size-options]');
      if (!toolbar || !template?.content.querySelector('input')) return;
      updatePaginationLinks(nextSource.closest('.shopify-section'), template);
      const text = copy[nextSource.dataset.language] || copy.de;
      const selectedGroups = readGroups(new URL(location.href));
      const count = Object.keys(selectedGroups).length ? Object.values(selectedGroups).reduce((total, values) => total + values.length, 0) : Number(nextSource.dataset.sizeCount);
      let button = toolbar.querySelector('.fendo-size-summary-button');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'fendo-size-summary-button';
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'fendo-selection-panel');
        button.setAttribute('aria-expanded', 'false');
        toolbar.insertBefore(button, toolbar.querySelector('collection-layout-switch'));
      }
      const label = text.sizes + ':' + count;
      // Explicit naming avoids repeating the CSS-generated short label on small screens.
      button.setAttribute('aria-label', count ? text.sizes + ': ' + count : text.sizes);
      if (button.dataset.label !== label) {
        button.innerHTML = '<svg class="fendo-size-summary-button__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 16 16 3l5 5L8 21Z M13 6l2 2 M10 9l2 2 M7 12l2 2 M4 15l2 2"/></svg>';
        const name = document.createElement('span');
        name.className = 'fendo-size-summary-button__name';
        name.dataset.short = nextSource.dataset.language === 'en' ? 'Sizes' : 'Grössen';
        name.textContent = text.sizes;
        button.append(name);
        if (count) {
          const badge = document.createElement('span');
          badge.className = 'fendo-size-summary-button__count';
          badge.textContent = String(count);
          button.append(badge);
        }
        button.dataset.label = label;
      }
      button.onclick = () => openPanel(nextSource, button);
      // Keep unrelated active filters accessible in their existing native controls.
      nextSource.querySelectorAll('.removable-facet').forEach(facet => {
        const link = facet.querySelector('a');
        if (!link) return;
        const removeUrl = new URL(link.href, location.href);
        const currentUrl = new URL(location.href);
        const parameters = Array.from(template.content.querySelectorAll('[data-size-parameter]')).map(group => group.dataset.sizeParameter);
        facet.hidden = parameters.some(parameter => removeUrl.searchParams.getAll(parameter).length < currentUrl.searchParams.getAll(parameter).length);
      });
      nextSource.dataset.enhanced = '';
      if (!initialVisitHandled && nextSource.dataset.autoSize === 'true') {
        initialVisitHandled = true;
        const url = new URL(location.href);
        const saved = readPreference();
        const action = initialAction(url, saved, promptSeen());
        if (action === 'restore') {
          openPanel(nextSource, button, false);
          const restored = selectionURL();
          if (restored.values.length && restored.url.href !== url.href) {
            location.replace(restored.url.href);
            return;
          }
        }
        autoPromptPending = action === 'prompt';
      }
      if (autoPromptPending && !document.querySelector('dialog[open], [role="dialog"][aria-modal="true"], .shopify-section--popup [open]')) {
        autoPromptPending = false;
        openPanel(nextSource, button);
      }
    });
  }
  function enhanceEmptyState(nextSource) {
    const section = nextSource.closest('.shopify-section');
    const empty = section?.querySelector('.empty-state');
    if (!empty) return;
    const url = new URL(location.href);
    const pairs = Array.from(url.searchParams.entries()).filter(([key]) => key.startsWith('filter.v.option.') && /(?:size|gr(?:ö|o|oe|ß|ss)|taille)/i.test(key));
    if (!pairs.length) return;
    const signature = url.search;
    if (empty.dataset.fendoSizeMessage === signature) return;
    empty.dataset.fendoSizeMessage = signature;
    const english = nextSource.dataset.language === 'en';
    const groups = readGroups(url);
    const values = Object.values(groups).flat();
    const selected = [...new Set(values.length ? values : pairs.map(([, value]) => value))].join(' / ');
    const message = empty.querySelector('p');
    if (message) message.textContent = english
      ? 'No styles are currently available with these filters in size ' + selected + '.'
      : 'Mit diesen Filtern sind derzeit keine Modelle in Grösse ' + selected + ' verfügbar.';
    let link = empty.querySelector('[data-fendo-size-alternative]');
    if (!link) {
      link = document.createElement('a');
      link.className = 'button button--secondary';
      link.dataset.fendoSizeAlternative = '';
      (empty.querySelector('.v-stack') || empty).append(link);
    }
    const target = new URL(nextSource.dataset.allProductsUrl || '/collections/all', location.origin);
    for (const [key, value] of pairs) target.searchParams.append(key, value);
    for (const [name, sizes] of Object.entries(groups)) {
      for (const value of sizes) target.searchParams.append('fendo_size_' + name, value);
    }
    target.searchParams.set('filter.v.availability', '1');
    link.href = target.href;
    link.textContent = english ? 'Explore all styles in your sizes' : 'Alle Modelle in Ihren Grössen entdecken';
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-fendo-clear-filters], .shopify-section--main-collection .empty-state facet-link a')) {
      persist([], {});
    }
  }, true);
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  }
  new MutationObserver(queue).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  document.addEventListener('facets:updated', queue);
  document.addEventListener('close', queue, true);
  new MutationObserver(queue).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue, { once: true });
  else queue();
}
